import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconReward(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M10.656 2.883c.503-1.177 2.185-1.177 2.688 0L15.4 7.698l5.262.443c1.286.109 1.808 1.699.832 2.538l-3.996 3.435 1.2 5.105c.293 1.247-1.07 2.23-2.175 1.568L12 18.08l-4.523 2.708c-1.105.662-2.468-.321-2.175-1.568l1.2-5.105-3.996-3.435c-.976-.84-.454-2.43.832-2.538l5.261-.443 2.057-4.815Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
